import { markRaw } from 'vue';
import request from '../../../../utils/request.js';

const EMPTY_TABLES = markRaw([]);
const EMPTY_COLUMNS = markRaw({});
const EMPTY_COMMENTS = markRaw({});

/** SQL 补全用的表名 / 列名缓存（按 连接 + 库 维度） */
export default {
    data() {
        return {
            tableCache: {},
            tableCommentsCache: {},
            tablePending: {},
            columnCache: {},
            columnRequested: {}
        };
    },
    computed: {
        tablesByDb() {
            const out = {};
            if (!this.conn || !this.conn.id) return out;
            (this.databases || []).forEach((db) => {
                const list = this.tableCache[this.conn.id + '|' + db];
                if (list && list.length) out[db] = list;
            });
            return out;
        },
        tableCommentsByDb() {
            const out = {};
            if (!this.conn || !this.conn.id) return out;
            (this.databases || []).forEach((db) => {
                const comments = this.tableCommentsCache[this.conn.id + '|' + db];
                if (comments && Object.keys(comments).length) out[db] = comments;
            });
            return out;
        }
    },
    methods: {
        ensureTables(database) {
            if (!this.conn || !this.conn.id) return;
            const db = database || '';
            const key = this.conn.id + '|' + db;
            if (this.tableCache[key] || this.tablePending[key]) return;
            this.tablePending[key] = true;
            request({
                url: '/dbManExec/tables',
                method: 'post',
                data: { connId: this.conn.id, database: db }
            }).then(res => {
                if (res.code == 0) {
                    const list = (res.meta && res.meta.tables) || [];
                    const arr = Array.isArray(list) ? list : [];
                    const names = [];
                    const comments = {};
                    arr.forEach((t) => {
                        const name = (t && typeof t === 'object') ? t.name : t;
                        if (!name) return;
                        names.push(name);
                        if (t && typeof t === 'object' && t.comment) {
                            comments[String(name).toUpperCase()] = t.comment;
                        }
                    });
                    this.tableCache[key] = markRaw(names);
                    this.tableCommentsCache[key] = markRaw(comments);
                    if (!this.columnCache[key]) this.columnCache[key] = EMPTY_COLUMNS;
                }
            }).catch(() => {
                // 后端对「取不到表名」已返回空列表、不报错；这里只是兜底
            }).finally(() => {
                this.tablePending[key] = false;
            });
        },
        onNeedColumns(database, tables) {
            if (!this.conn || !this.conn.id || !tables || !tables.length) return;
            const db = database || '';
            const key = this.conn.id + '|' + db;
            if (!this.columnCache[key]) this.columnCache[key] = EMPTY_COLUMNS;
            const cache = this.columnCache[key] || {};
            const existing = new Set(Object.keys(cache).map(k => k.toUpperCase()));
            const missing = [];
            tables.forEach(t => {
                if (!t) return;
                const upper = String(t).toUpperCase();
                const pendKey = key + '::' + upper;
                if (existing.has(upper) || this.columnRequested[pendKey]) return;
                this.columnRequested[pendKey] = true;
                missing.push(t);
            });
            if (!missing.length) return;
            missing.forEach((table) => {
                request({
                    url: '/dbManExec/tableColumns',
                    method: 'post',
                    silent: true,
                    data: { connId: this.conn.id, database: db, table }
                }).then(res => {
                    if (res.code != 0) return;
                    const cols = (res.meta && res.meta.columns) || [];
                    const list = cols.map(c => ({ name: c.name, type: c.type || '', comment: c.comment || '' }));
                    this.columnCache[key] = markRaw(Object.assign({}, this.columnCache[key] || {}, { [table]: list }));
                }).catch(() => {
                    delete this.columnRequested[key + '::' + String(table).toUpperCase()];
                });
            });
        },
        tablesFor(database) {
            return this.tableCache[this.conn.id + '|' + (database || '')] || EMPTY_TABLES;
        },
        tableCommentsFor(database) {
            return this.tableCommentsCache[this.conn.id + '|' + (database || '')] || EMPTY_COMMENTS;
        },
        columnsFor(database) {
            return this.columnCache[this.conn.id + '|' + (database || '')] || EMPTY_COLUMNS;
        }
    }
};
